module.exports = __webpack_public_path__ + "static/img/10.829f2d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/eng/10.png
// module id = Y8Ey
// module chunks = 0